import {IOperativeObservation} from '../message-models/operative-observation.interface';
import {Observation} from './observation.class';

export class OperativeObservation implements IOperativeObservation {
    id: string;
    operativeId: string;
    observationId: string;
    observation: Observation;
    operativeName: string;
    operativeFirstName: string;
    operativeLastName: string;
    constructor(iOperativeObservation: IOperativeObservation) {
      this.id = iOperativeObservation?.id || '00000000-0000-0000-0000-000000000000';
      this.operativeId = iOperativeObservation?.operativeId || '00000000-0000-0000-0000-000000000000';
      this.observationId = iOperativeObservation?.observationId || '00000000-0000-0000-0000-000000000000';
      this.observation = new Observation(iOperativeObservation?.observation);
      this.operativeName = iOperativeObservation.operativeName || '' ;
      this.operativeFirstName = iOperativeObservation.operativeFirstName || '' ;
      this.operativeLastName = iOperativeObservation.operativeLastName || '' ;
    }



  }
